export default "__VITE_ASSET__9e212d67__"